// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineModal_container__pX0Cm","message":"OfflineModal_message__syAQr"};